import _data from "../data/glossary";

import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    data: _data,
    query: "",
    strategy: "",
    reform: "",
    masterplan: ""
  },
  getters: {
    allVocabulary: state => {
      return state.data._data;
    },
    getVocabularyByAlphabet: state => _idx => {
      return state.data._data.filter(x => x.firstalpha === _idx);
    },
    getVocabularyByWord: state => _idx => {
      return state.data._data.filter(x => x.keyword === _idx);
    },
    getVocabularyByStrategy: state => _idx => {
      return state.data._data.filter(x => x.sappear == _idx);
    },
    getVocabularyByReform: state => _idx => {
      return state.data._data.filter(x => x.rappear == _idx);
    },
    getVocabularyByMasterplan: state => _idx => {
      return state.data._data.filter(x => x.mappear == _idx);
    },
    getAllVocabularyKeyword: state => {
      return state.data._data.map(x => x.keyword);
    },
    isVocabularyExist: state => _idx => {
      if (state.data._data.filter(x => x.keyword === _idx).length > 0) {
        return true;
      } else {
        return false;
      }
    }
  }
});

export default store;
